export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11477.6f90710e.jpg";